import { render, staticRenderFns } from "./CurrentCheckoxesList.vue?vue&type=template&id=d6a747d8&scoped=true&"
import script from "./CurrentCheckoxesList.vue?vue&type=script&lang=js&"
export * from "./CurrentCheckoxesList.vue?vue&type=script&lang=js&"
import style0 from "./CurrentCheckoxesList.vue?vue&type=style&index=0&id=d6a747d8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6a747d8",
  null
  
)

export default component.exports